import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-navy-light py-8 md:py-24 px-4" data-id="element-69">
      <div className="max-w-3xl mx-auto" data-id="element-70">
        <motion.div className="space-y-4 md:space-y-6 text-base md:text-xl text-gray-300" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-71">
          <p data-id="element-72">No es que te falte trabajo. No es que no seas bueno.</p>
          <p data-id="element-73">El problema es otro.</p>

          <div className="bg-navy-dark p-4 md:p-6 rounded-lg border border-red-500/20" data-id="element-74">
            <p className="font-bold text-white text-xl md:text-2xl mb-3" data-id="element-75">
              👉 No tenés un sistema.
            </p>
            <p className="mb-3" data-id="element-76">Y sin sistema…</p>
            <ul className="space-y-2 font-medium text-red-400 text-sm md:text-base" data-id="element-77">
              <li className="flex items-center gap-2" data-id="element-78">❌ Perdés clientes</li>
              <li className="flex items-center gap-2" data-id="element-79">❌ Perdés tiempo</li>
              <li className="flex items-center gap-2" data-id="element-80">❌ Perdés dinero</li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}